import { createSlice } from "@reduxjs/toolkit";
import { pushDynamicTab } from "../utils/dynamicTabs";

// 🔹 Versioning for state persistence
const SLICE_VERSION = "1.1";

// 🔹 Exportable initial state (used in store.js for version checks)
export const initialState = {
  _version: SLICE_VERSION,
  contracts: [
    { id: "contracts", name: "Contracts", isDynamic: false },
    { id: "lanes", name: "Lanes", isDynamic: false },
    { id: "routes", name: "Routes", isDynamic: false },
    { id: "rates", name: "Rates", isDynamic: false },
    // { id: "templates", name: "Templates", isDynamic: false },
    // { id: "drafts", name: "Drafts", isDynamic: false },
  ],
  dynamicTabs: [],
  activeTab: 0,
};

const contractsSlice = createSlice({
  name: "contracts",
  initialState,
  reducers: {
    addTab: (state, action) => {
      const { tabData } = action.payload;
      const dynamicId =
        window.crypto?.randomUUID?.() ||
        `${Date.now()}-${Math.random().toString(36).slice(2, 15)}-${state.dynamicTabs.length}`;

      pushDynamicTab(
        state,
        {
          id: `dyn-${dynamicId}`,
          name: tabData?.name || `New Contract ${state.dynamicTabs.length + 1}`,
          type: tabData?.type || "contract",
          searchTerm: tabData?.searchTerm,
          contractId: tabData?.contractId,
          contractData: tabData?.contractData,
          originTabName: tabData?.originTabName,
          expandedDataKey: tabData?.expandedDataKey,
          isDynamic: true,
          createdAt: Date.now(),
        },
        state.contracts.length
      );
    },

    removeTab: (state, action) => {
      const { tabIndex } = action.payload;
      if (tabIndex < state.contracts.length) return;

      const dynamicIndex = tabIndex - state.contracts.length;
      state.dynamicTabs.splice(dynamicIndex, 1);
      state.activeTab = Math.min(
        state.activeTab,
        state.contracts.length + state.dynamicTabs.length - 1
      );
    },

    setActiveTab: (state, action) => {
      const { index } = action.payload;
      const maxIndex = state.contracts.length + state.dynamicTabs.length - 1;
      state.activeTab = Math.min(Math.max(index, 0), maxIndex);
    },

    resetTabs: (state) => {
      state.dynamicTabs = [];
      state.activeTab = 0;
    },

    setSelectedTemplate: (state, action) => {
      state.selectedTemplate = action.payload;
    },
  },
});

export const {
  addTab,
  removeTab,
  setActiveTab,
  setSelectedTemplate,
  resetTabs,
} = contractsSlice.actions;

export default contractsSlice.reducer;
